<template>
    <div class='teddybear' :class='{ active: isActive }' id='teddybear' v-bind:style='mystyle' @click='isActive =!isActive'>
        <div class='teddybear-inner'>
        <svg xmlns="http://www.w3.org/2000/svg" width="210mm" height="297mm" viewBox="0 0 210 297" :class="beartype" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><ellipse class="bearbody" transform="matrix(-.89353 -.449 -.58349 .81212 0 0)" ry="26.764" rx="19.333" cy="127.018" cx="-165.65" fill="#803300"/><ellipse class="bearbody" cx="6.651" cy="222.278" rx="19.333" ry="26.764" transform="matrix(.89353 -.449 .58349 .81212 0 0)" fill="#803300"/><ellipse class="bearbody" transform="matrix(.93864 .3449 -.33916 .94073 0 0)" ry="12.668" rx="21.941" cy="68.42" cx="175.066" fill="#803300"/><ellipse class="bearbody" cx="-22.058" cy="140.691" rx="21.941" ry="12.668" transform="matrix(-.93864 .3449 .33916 .94073 0 0)" fill="#803300"/><ellipse class="bearoutlines" transform="scale(-1 1)" cx="-80.157" cy="66.133" rx="14.514" ry="15.897" fill="#a40" stroke="#803300" stroke-width="4.571"/><ellipse class="bearoutlines" ry="15.897" rx="14.514" cy="66.4" cx="127.023" fill="#a40" stroke="#803300" stroke-width="4.571"/><ellipse class="bearbody" ry="42.113" rx="31.32" cy="141.297" cx="104.479" fill="#803300"/><ellipse class="bearbody" ry="33.502" rx="33.235" cy="87.979" cx="103.565" fill="#803300"/><ellipse class="bearoutlines" ry="18.539" rx="14.397" cy="180.07" cx="145.127" fill="#a40" stroke="#803300" stroke-width="3.706"/><ellipse class="bearlight" ry="11.626" rx="17.64" cy="98.682" cx="103.857"/><ellipse class="bearface" ry="3.475" rx="5.613" cy="93.738" cx="104.392" fill="#000600"/><path class="bearface" d="M104.392 95.341s-1.357 9.963 10.156 9.89" fill="none" stroke="#000" stroke-width="2.265" stroke-linecap="round"/><ellipse cx="114.013" cy="78.503" rx="3.742" ry="5.88" class="bearface beareyes" fill="#2b1100"/><ellipse cx="145.261" cy="189.558" rx="5.88" ry="4.276" fill="#000600"/><ellipse cx="145.996" cy="171.383" rx="3.007" ry="5.078" fill="#000600"/><ellipse cx="62.886" cy="213.776" rx="2.777" ry="4.704" transform="matrix(.93862 -.34496 .37213 .92818 0 0)" fill="#000600"/><ellipse transform="matrix(.94076 .33907 -.31155 .95023 0 0)" ry="4.704" rx="2.777" cy="114.703" cx="200.486" fill="#000600"/><ellipse class="bearlight" ry="18.843" rx="21.649" cy="154.412" cx="104.77" fill="#a40"/><ellipse class="bearoutlines" ry="9.058" rx="8.389" cy="128.754" cx="152.344" fill="#a40" stroke="#803300" stroke-width="2.736" stroke-linecap="round"/><ellipse class="bearoutlines" transform="scale(-1 1)" cx="-64.412" cy="180.07" rx="14.397" ry="18.539" fill="#a40" stroke="#803300" stroke-width="3.706"/><path class="bearface" d="M104.392 95.341s1.357 9.963-10.157 9.89" fill="none" stroke="#000" stroke-width="2.265" stroke-linecap="round"/><ellipse ry="5.88" rx="3.742" cy="78.503" cx="-94.77" transform="scale(-1 1)" class="bearface beareyes" fill="#2b1100"/><ellipse ry="4.276" rx="5.88" cy="189.558" cx="-64.278" transform="scale(-1 1)" fill="#000600"/><ellipse ry="5.078" rx="3.007" cy="171.383" cx="-63.543" transform="scale(-1 1)" fill="#000600"/><ellipse transform="matrix(-.93862 -.34496 -.37213 .92818 0 0)" ry="4.704" rx="2.777" cy="141.462" cx="-131.686" fill="#000600"/><ellipse cx="1.291" cy="185.782" rx="2.777" ry="4.704" transform="matrix(-.94076 .33907 .31155 .95023 0 0)" fill="#000600"/><ellipse class="bearoutlines" transform="scale(-1 1)" cx="-57.196" cy="128.754" rx="8.389" ry="9.058" fill="#a40" stroke="#803300" stroke-width="2.736" stroke-linecap="round"/><path class="bearbody" d="M100.59 56.075c1.713-2.678 5.644-2.315 5.644-2.315s-2.408.056-3.58 3.028" fill="#803300"/><path class="bearbody" d="M101.287 56.723c-1.173-2.732-5.297-2.8-5.297-2.8s2.465.306 3.017 3.262M106.53 55.339c2.028-1.931 5.976-.601 5.976-.601s-2.448-.569-3.96 1.762M94.718 135.772c2.028 1.931 5.977.601 5.977.601s-2.449.569-3.96-1.762M102.524 134.601c1.22 1.773 4.245 1.282 4.245 1.282s-1.843.106-2.639-1.905M108.432 134.973c.894 1.958 3.958 2 3.958 2s-1.833-.216-2.268-2.335" fill="#803300"/></svg>
        </div>
    </div>
</template>

<script>
let beartypes = [
'bearmedium','beardark','beardarker','bearblack','bearwhite'
];

export default {
    name: 'teddy-bear',
    data() {
        return {
           // top: 0,
           // left: 0,
            display: 'none',
            isActive: false,
            rotate: 0,
            beartype: 'bearmedium'
        }
    },
    watch: {
        '$route': function() {

        }
    },
    computed: {
        mystyle() {
            return {
                top: this.top, 
                left: this.left,
                display: this.display,
                transform: `rotate(${this.rotate}deg)`
            };
        }
    },
    methods: {
        refresh() {
            this.$nextTick(()=>{
                let tiles = document.getElementsByClassName('resourceTile');
                
                if (tiles.length > 0) {
                    let item = Math.floor(Math.random() * tiles.length);
                    this.top = (tiles[item].offsetTop -45) + 'px';
                    this.left = tiles[item].offsetLeft + 'px';
                    this.display = 'block';
                    this.rotate = Math.floor(Math.random() * 30) -15;
                    this.beartype = beartypes[Math.floor(Math.random() * beartypes.length)]
                }
            });
        }
    },
    created() {
        this.$eventBus.$on('resources-loaded', this.refresh);
    },
    beforeDestroy() {
        this.$eventBus.$off('resources-loaded');
    }
}
</script>

<style lang='less'>
@keyframes shake {
  0% { transform:   rotate(0deg); }
  20% { transform:  rotate(-5deg); }
  40% { transform: rotate(5deg); }
  60% { transform:  rotate(-5deg); }
  80% { transform:  rotate(5deg); }
  100% { transform:  rotate(0deg); }
}

 
.bearbody {
    stroke-opacity:1;
    stroke:none;
    stroke-dasharray:none;
    stroke-miterlimit:4;
    fill:#803300;
}
.bearoutlines {
    stroke-opacity:1;
    stroke:#803300;
    stroke-miterlimit:4;
    stroke-dasharray:none;
    fill:#aa4400;
}
.bearlight {
    stroke-opacity:1;
    fill-opacity:1;
    fill: #aa4400;
}

.bearface {
    stroke-opacity:1;
    stroke-linecap:round;
    stroke-miterlimit:4;
    stroke-dasharray:none;
}
.beareyes {
    stroke-opacity:1;
    fill-opacity:1;
    fill: black;
}

svg.bearmedium {
    .bearbody {
        fill: #803300;
    }

    .bearoutlines {
        stroke:#803300;
        fill:#aa4400;
    }

    .bearlight {
        fill: #aa4400;
    }

    .bearface {
        stroke: black;
    }
    .beareyes {
        fill: black;
    }
}

svg.beardark {
    .bearbody {
        fill: #552200;
    }

    .bearoutlines {
        stroke:#552200;
        fill:#803300;
    }

    .bearlight {
        fill: #803300;
    }

    .bearface {
        stroke: black;
    }
    .beareyes {
        fill: black;
    }
}

svg.beardarker {
    .bearbody {
        fill: #2b1100;
    }

    .bearoutlines {
        stroke:#2b1100;
        fill:#a05a2c;
    }

    .bearlight {
        fill: #a05a2c;
    }

    .bearface {
        stroke: black;
    }
    .beareyes {
        fill: black;
        stroke: #a05a2c;
        stroke-width: 2;
    }
}

svg.bearblack {
    .bearbody {
        fill: black;
    }

    .bearoutlines {
        stroke:#2b1100;
        fill: black;
    }

    .bearlight {
        fill: #a05a2c;
    }

    .bearface {
        stroke: black;
    }
    .beareyes {
        fill: black;
        stroke: #a05a2c;
        stroke-width: 2;
    }
}

svg.bearwhite {
    .bearbody {
        fill: white;
        stroke: black;
    }

    .bearoutlines {
        stroke: black;
        fill: white;
    }

    .bearlight {
        fill: white;
        stroke: black;
    }

    .bearface {
        stroke: black;
    }
    .beareyes {
        fill: white;
        stroke: black;
        stroke-width: 3;
    }
}


.teddybear {
    position: absolute;

    top: 350px;
    left: 300px;
    transition: all 0.5s;

    svg {
        width: 150px;
        height: 200px;
        outline: none;
        transition: all 0.5s;
    }

    &.active {
        z-index: 1;
        
    }

    &.active svg {
        transform: scale(2.5);
        
    }

    .teddybear-inner:hover {
        animation: shake 0.5s;
    }
}
</style>